import { assertNull } from "common/assert";
import { logError } from "common/error";
import { cancel, delaySound, Waiter } from "common/promises";
import log from "loglevel";
import { spritesDurations } from "./resources/sound";
export class BackgroundSoundPlayer {
    constructor(sound) {
        this.playingAB = null;
        this.playingC = null;
        this.playingD = null;
        this.playingE = null;
        this.playingHeart = null;
        this.speed = 0;
        this.settingSpeed = null;
        this.sound = sound;
    }
    play() {
        this.speed = 0;
        assertNull(this.playingAB, "playingAB");
        this.play0();
    }
    dispose() {
        var _a, _b, _c, _d, _e;
        (_a = this.playingAB) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
        (_b = this.playingC) === null || _b === void 0 ? void 0 : _b.canceler.cancel();
        (_c = this.playingD) === null || _c === void 0 ? void 0 : _c.canceler.cancel();
        (_d = this.playingE) === null || _d === void 0 ? void 0 : _d.canceler.cancel();
        (_e = this.playingHeart) === null || _e === void 0 ? void 0 : _e.canceler.cancel();
    }
    playFinish() {
        this.setSpeedAsync(4).catch(logError);
    }
    setSpeed(speed) {
        this.setSpeedAsync(speed).catch(logError);
    }
    async setSpeedAsync(speed) {
        var _a, _b, _c, _d, _e;
        if (this.speed === speed) {
            return;
        }
        this.speed = speed;
        while (this.settingSpeed != null) {
            await this.settingSpeed.wait();
        }
        this.settingSpeed = new Waiter();
        (_a = this.playingAB) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
        (_b = this.playingC) === null || _b === void 0 ? void 0 : _b.canceler.cancel();
        (_c = this.playingD) === null || _c === void 0 ? void 0 : _c.canceler.cancel();
        (_d = this.playingE) === null || _d === void 0 ? void 0 : _d.canceler.cancel();
        (_e = this.playingHeart) === null || _e === void 0 ? void 0 : _e.canceler.cancel();
        // const playingSoundFinished = Promise.all([
        //   this.playingAB?.promise ?? Promise.resolve(),
        //   this.playingC?.promise ?? Promise.resolve(),
        //   this.playingD?.promise ?? Promise.resolve(),
        //   this.playingE?.promise ?? Promise.resolve(),
        //   this.playingHeart?.promise ?? Promise.resolve(),
        // ]);
        this.playingAB = null;
        this.playingC = null;
        this.playingD = null;
        this.playingE = null;
        this.playingHeart = null;
        this.playNum(speed);
        this.settingSpeed.trigger();
        this.settingSpeed = null;
        // await playingSoundFinished;
    }
    playNum(speed) {
        log.info("playNum", speed);
        switch (speed) {
            case 0:
                this.play0();
                break;
            case 1:
                this.play1();
                break;
            case 2:
                this.play2();
                break;
            case 3:
                this.play3();
                break;
            case 4:
                this.play4();
                break;
            default:
                log.warn("not implemented yet");
            // throw new Error("invalid speed");
        }
    }
    play0() {
        this.playingAB = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await this.sound.awaitPlay("background1");
                await this.sound.awaitPlay("background2");
            }
        });
        this.playingC = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await this.sound.awaitPlay("background3");
                await delaySound(50);
            }
        });
    }
    play1() {
        this.playingAB = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await this.sound.awaitPlay("background1");
                await this.sound.awaitPlay("background2");
            }
        });
        this.playingC = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await this.sound.awaitPlay("background3");
                await delaySound(50);
            }
        });
        this.playingHeart = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await this.sound.awaitPlay("heart");
                await delaySound(50);
            }
        });
    }
    play2() {
        this.playingAB = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                this.sound.play("background1");
                await delaySound(spritesDurations["background1"] * 0.8);
                this.sound.play("background2");
                await delaySound(spritesDurations["background2"] * 0.8);
            }
        });
        this.playingC = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await this.sound.awaitPlay("background3");
                await delaySound(25);
            }
        });
        this.playingHeart = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                this.sound.play("heart");
                await delaySound(spritesDurations["heart"] * 0.8);
            }
        });
    }
    play3() {
        this.playingAB = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await this.sound.awaitPlay("background1");
                await delaySound(100);
            }
        });
        this.playingC = cancel.root(async (canceler) => {
            while (true) {
                for (let i = 0; i < 5; i += 1) {
                    canceler.check();
                    await this.sound.awaitPlay("background3");
                    await delaySound(15);
                }
                await delaySound(150);
            }
        });
        this.playingD = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                this.sound.play("background4");
                await delaySound(spritesDurations["background4"] * 0.5);
            }
        });
        this.playingHeart = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                this.sound.play("heart");
                await delaySound(spritesDurations["heart"] * 0.8);
            }
        });
    }
    play4() {
        this.playingAB = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await this.sound.awaitPlay("background1");
                await delaySound(100);
            }
        });
        this.playingC = cancel.root(async (canceler) => {
            while (true) {
                for (let i = 0; i < 5; i += 1) {
                    canceler.check();
                    await this.sound.awaitPlay("background3");
                    await delaySound(15);
                }
                await delaySound(150);
            }
        });
        this.playingD = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                this.sound.play("background4");
                await delaySound(spritesDurations["background4"] * 0.5);
            }
        });
        this.playingE = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                this.sound.play("background5");
                await delaySound(spritesDurations["background5"] * 0.66);
            }
        });
        this.playingHeart = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                this.sound.play("heart");
                await delaySound(spritesDurations["heart"] * 0.8);
            }
        });
    }
}
//# sourceMappingURL=backgroundSoundPlayer.js.map